import axios from 'axios'; // https://designrevision.com/react-axios/
import axiosRetry from 'axios-retry';
import config from '~/config';

const _api = axios.create({
  baseURL: config.revanceSSOEndpoint.URL,
  responseType: 'json'
})

const axiosRetryOptions = {
  retries: 2,
  retryDelay: (retryCount) => {
    return retryCount * 100;
  },
}

export const apiController = {
  // getAuth: async () => {
  //   return new Promise((resolve, reject) => {
  //     axiosRetry(_api, axiosRetryOptions);
  //     _api.get('/getauth', { timeout: 10000 })
  //     .then((res) => {
  //       if (res.data.status && res.data.status.username) {
  //         resolve(res.data);
  //       } else {
  //         reject(res.data);
  //       }
  //     }).catch((err) => {
  //       reject(err);
  //     })
  //   })
  // },
  decryptAuth: async (ref) => {
    return new Promise((resolve, reject) => {
      axiosRetry(_api, axiosRetryOptions);
      _api.get('/dauth?ref=' + ref, { timeout: 10000 })
      .then((res) => {
        if (res.data.status && res.data.status.username) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      }).catch((err) => {
        reject(err);
      })
    })
  }
}

export default apiController;


// WEBPACK FOOTER //
// ./src/utils/ssoAPI.ts